export default __webpack_public_path__ + "static/media/gal3.3bed4a0d.jpeg";